module.exports = __webpack_public_path__ + "img/form_tablet.826f175c.svg";